import React, { useMemo, useState } from 'react';
import { Button, ToastMessage } from '@cokitchen/cokitchen-components';
import useItemRequestContext from 'contexts/item-request.context/context';
import { useNavigate, useParams } from 'react-router-dom';
import { apiService } from 'services/base.service';
import { toast } from 'react-toastify';

import MainstoreRequestItemReturn from 'components/mainstore-request-item-return';
import { RequestItemType } from 'models/item-request.model';
import RequestDetailsWrapper from 'components/base/request-details-wrapper';

const ReturnItems = () => {
  const router = useNavigate();
  const { itemRequestToEdit } = useItemRequestContext();
  const [updatedRequestItems, setUpdatedRequestItems] = useState([] as RequestItemType[]);
  const [loading, setLoading] = useState(false);
  const { ids } = useParams();

  const handleUpdate = async () => {
    const data = {
      items: updatedRequestItems
    };
    try {
      setLoading(true);
      const res = await apiService.post(
        `kitchen-store/kitchen-request/${itemRequestToEdit?.id}/send-items`,
        {
          data
        }
      );
      if (res) {
        toast(<ToastMessage type='success' message=' Update successful' />);
        router(-1);
      }
    } catch (err: any) {
      toast(<ToastMessage type='error' message={err.response.data.message} />);
    } finally {
      setLoading(false);
    }
  };
  const requestItems = useMemo(
    () =>
      itemRequestToEdit?.items

        ?.filter((item) => ids?.includes(item.id))
        ?.sort((a, b) => a.quantity - b.quantity),
    [itemRequestToEdit, ids]
  );
  return (
    <RequestDetailsWrapper
      codeId={itemRequestToEdit?.code}
      header='Update returned items'
      subHeader='State the quantity received in good condition where necessary'>
      {requestItems?.map((item) => (
        <MainstoreRequestItemReturn
          key={item.id}
          item={item}
          onItemChange={(item) => setUpdatedRequestItems([...updatedRequestItems, item])}
        />
      ))}
      <div>
        <div className='flex gap-6 items-center justify-end mt-6 mx-[28px] ml-auto'>
          <Button variant='link' color='gray' small onClick={() => router(-1)}>
            Back
          </Button>
          <Button
            variant='block'
            color='primary'
            small
            className='w-[153px] h-[43px]'
            onClick={handleUpdate}
            loading={loading}
            disabled={
              itemRequestToEdit?.items?.some((item) => item.new_quantity_sent > item.quantity) ||
              loading
            }>
            Update
          </Button>
        </div>
      </div>
    </RequestDetailsWrapper>
  );
};

export default ReturnItems;
